module.exports = __webpack_public_path__ + "static/media/speaker-samuel-mobile.da20794c.jpg";